import React, { Component } from "react";
import PropTypes from "prop-types";
import DispatchTableHead from "./TableHead";

const MAX_VEHICLES = 6;

class VehiclesTable extends Component {
  handleOpenModal = (modalData) => {
    const { handleOpenItemModal } = this.props;
    const content = this.modalContent(modalData);
    handleOpenItemModal(content);
  };

  handleCloseModal = () => {
    const { handleCloseItemModal } = this.props;
    handleCloseItemModal();
  };

  modalContent = (modalData) => {
    if (!modalData) {
      return;
    }
    return (
      <div className="details">
        <div className="vc">
          <label className="control-label">Nom :</label>
          <p>{modalData.name}</p>
        </div>
        <div className="vc">
          <label className="control-label">Note :</label>
          <p>{modalData.note}</p>
        </div>
      </div>
    );
  };

  render() {
    const {
      trucks,
      toolboxes,
      handleToggleItemModal,
      handleDeleteClick,
      copyType,
      handleCopy,
      handlePaste,
      userType,
    } = this.props;

    const items = trucks.concat(toolboxes);
    const itemsLength = items ? items.length : 0;
    const emptyCells = new Array(Math.max(MAX_VEHICLES - itemsLength, 0)).fill(
      0
    );

    return (
      <div>
        <table className="vcs">
          <DispatchTableHead
            numberOfItems={itemsLength}
            title="véhicules"
            span={2}
            onAddClick={() => handleToggleItemModal(3)}
            active={copyType === "trucksAndToolboxes"}
            userType={userType}
            onOptionClick={() =>
              copyType === "trucksAndToolboxes" ? handlePaste() : handleCopy()
            }
          />
          <tbody>
            {trucks.map((item) => {
              if (item) {
                return (
                  <tr key={item.id}>
                    <td
                      onClick={() => this.handleOpenModal(item)}
                      className={item.note ? "has_note" : ""}
                    >
                      {item.name}
                    </td>
                    {userType === "admin" && (
                      <td
                        className="delete-icon"
                        onClick={() => handleDeleteClick(item.id, "trucks")}
                      >
                        <i className="fa fa-times" aria-hidden="true" />
                      </td>
                    )}
                  </tr>
                );
              }
              return <React.Fragment></React.Fragment>;
            })}
            {toolboxes.map((item) => {
              if (item) {
                return (
                  <tr key={item.id}>
                    <td
                      onClick={() => this.handleOpenModal(item)}
                      className={item.note ? "has_note" : ""}
                    >
                      {item.name}
                    </td>
                    {userType === "admin" && (
                      <td
                        className="delete-icon"
                        onClick={() => handleDeleteClick(item.id, "toolboxes")}
                      >
                        <i className="fa fa-times" aria-hidden="true" />
                      </td>
                    )}
                  </tr>
                );
              }
              return <React.Fragment></React.Fragment>;
            })}
            {emptyCells.map((cell, index) => (
              <tr className="empty" key={`empty-${index}`}>
                <td />
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

VehiclesTable.propTypes = {
  employees: PropTypes.array,
  handleToggleItemModal: PropTypes.func,
  handleDeleteClick: PropTypes.func,
};

export default VehiclesTable;
